module.exports = __webpack_public_path__ + "static/img/tabbt_4.743964a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt_4.png
// module id = YnUu
// module chunks = 1